import $ from 'jquery';
import {__} from "./translations.ts";


export class LeaveConfirmation {

    dirty = false;
    formSubmitting = false;
    message = '';

    constructor() {
        this.message = __('are-you-sure-to-leave');
        $('form').on('submit', _ => {
            this.formSubmitting = true;
        });

        $('input,select,textarea').on('change', _ => {
            this.dirty = true;
        });

        // apply changeDetection on trumbowyg components as well
        $('textarea.wysiwyg').each((index, item) => {
            $(item).trumbowyg().on('tbwchange', () => this.dirty = true);
        });

        $(document).ready(_ => {
            $(window).on('beforeunload', e => {
                if (this.formSubmitting || !this.dirty) {
                    return undefined;
                }

                (e || window.event).returnValue = this.message; //Gecko + IE
                return this.message; //Gecko + Webkit, Safari, Chrome etc.
            });
        })
    }
}
